export default __webpack_public_path__ + "static/media/C264253.7826eccc.jpg";